export default __webpack_public_path__ + "static/media/band3_flat2.518ee44e.png";